import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as ReportParameterActions from './report-parameter-options.actions';
import { ReportClientService } from '@mode/shared/data-access-webapp';
import { of } from 'rxjs';

@Injectable()
export class ReportParameterOptionsEffects {
  loadReportParameterOptions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReportParameterActions.loadReportParameterOptions),
      switchMap((action) =>
        this.reportViewerService.getReportParameterOptions(action.accountId, action.reportToken, action.reportRunToken)
      ),
      map((options) => ReportParameterActions.loadReportParameterOptionsSuccess({ options })),
      catchError((error) => of(ReportParameterActions.loadReportParameterOptionsFailure({ error })))
    );
  });

  constructor(
    private actions$: Actions,
    private reportViewerService: ReportClientService
  ) {}
}
